import React, { useEffect, useState } from "react";
import FareBreakdown from "./FareBreakdown";

const PricingInfo = ({ info, isPreview, isFromPayment }) => {
  const [PricingInfo, setPricingInfo] = useState();
  useEffect(() => {
    if (isPreview) {
      setPricingInfo({ ...info, Fare: info.FareOptions })
    }
    else if (isFromPayment) {
      setPricingInfo({ ...info, Fare: info.Pricing })
    }
    else {
      setPricingInfo(info);
    }
  }, [])

  return (
    PricingInfo && <div className="col-span-4 sticky top-3">
      <div className="bg-background rounded-lg p-3 shadow">
        <table className="w-full">
          <thead>
            {PricingInfo.Fare.GTotalFare > 0 && (
              <tr className="font-medium text-lg">
                <td className="py-1">Total Fare</td>
                <td className="text-right py-1">
                  {PricingInfo.Fare.Currency + " "} {PricingInfo.Fare.GTotalFare}
                </td>
              </tr>
            )}
            {/* {!isPreview && PricingInfo.Fare.FareBreakDowns.length > 0 && (
              <tr className="border-b">
                <td className="text-muted-foreground text-sm py-3">
                  {PricingInfo.Fare.FareBreakDowns.map((pd, i) => {
                    return (
                      <span key={pd.Passenger.Code + "_" + i}>
                        {pd.Passenger.QTY + "" + pd.Passenger.Code + " "}
                      </span>
                    );
                  })}
                </td>
              </tr>
            )} */}
          </thead>
          {/* <tbody className="text-muted-foreground text-sm">
            {PricingInfo.Fare.GTotalBaseFare > 0 && (
              <tr>
                <td className="py-1">Base Fare</td>
                <td className="text-right py-1">
                  {PricingInfo.Fare.Currency + " "}
                  {PricingInfo.Fare.GTotalBaseFare}
                </td>
              </tr>
            )}
            {PricingInfo.Fare.GTotalTax > 0 && (
              <tr>
                <td className="py-1">TAX</td>
                <td className="text-right py-1">
                  {PricingInfo.Fare.Currency + " "}
                  {PricingInfo.Fare.GTotalTax}
                </td>
              </tr>
            )}
            {PricingInfo.Fare.Discount > 0 && (
              <tr>
                <td className="py-1">Discount</td>
                <td className="text-right py-1">
                  {PricingInfo.Fare.Currency + " "} {PricingInfo.Fare.Discount}
                </td>
              </tr>
            )}
            {PricingInfo.Fare.Charges > 0 && (
              <tr>
                <td className="py-1">Service Charge</td>
                <td className="text-right py-1">
                  {PricingInfo.Fare.Currency + " "} {PricingInfo.Fare.Charges}
                </td>
              </tr>
            )}
          </tbody> */}
        </table>
        {/* {PricingInfo.Fare.FareBreakDowns?.length > 0 && <FareBreakdown fareBreakdowns={PricingInfo.Fare.FareBreakDowns} />} */}
      </div>
    </div>
  );
};

export default PricingInfo;
